import { useUserStore } from "@/store/user";

const getPrice = (ticket) => ticket.local_rates.net_rate_eur;
const getAvailable = (ticket) => ticket.stock + ticket.reserved;

const byPrice = (a, b) => getPrice(a) - getPrice(b);
const byAvailable = (a, b) => getAvailable(a) - getAvailable(b);
const byTicketId = (a, b) => a.ticket_id.localeCompare(b.ticket_id);
const bySupplierPref = (a, b) => a.is_xs2event_supplier - b.is_xs2event_supplier;

const byAscendingPreference = (a, b) => byPrice(b, a) || bySupplierPref(a, b) || byAvailable(b, a) || byTicketId(a, b);

export const validateTicketCount = (n, ticket) => {
  if (n === getAvailable(ticket)) {
    return true;
  }
  if (ticket.flags?.includes("pairs_only") && n & 1) {
    return;
  }
  if (ticket.flags?.includes("no_max_minus_1") && n === getAvailable(ticket) - 1) {
    return;
  }
  return true;
};

export const hasStock = (subcategory) => subcategory.tickets.some((ticket) => ticket.stock | ticket.reserved);

export const createTicketCountOptions = (tickets, max) => {
  const index = [{ n: 0 }];
  const indexTicketCountOptions = (ticket) => {
    const { stock, reserved } = ticket;
    const available = stock + reserved;
    for (let n = 1; n <= available && n <= max; ++n) {
      const isValid = validateTicketCount(n, ticket);
      if (isValid) {
        index[n] = { n, ticket };
      }
    }
  };
  tickets?.slice().sort(byAscendingPreference).forEach(indexTicketCountOptions);
  return index;
};

export const getSubcategoryKey = (ticket) =>
  useUserStore().isAdmin ? ticket.ticket_id : ticket.event_id + "-" + ticket.category_name + "-" + ticket.sub_category;
